import styled, { keyframes } from "styled-components";
const blinkingCursor = keyframes`
0%{
opacity:1}
100%{
opacity:0}`;
const enterKeyframes = keyframes`
  0% {
    transform: translateX(0px) translateY(10px) scale(1) rotate(0deg) skewX(0deg) skewY(0deg);
    opacity: 0.01;
    filter: blur(4px);
  }
  100% {
    transform: none;
    opacity: 1;
    filter: blur(0);
  }
    
`;

const exitKeyframes = keyframes`
  0% {
    transform: none;
    opacity: 1;
    filter: blur(0);
  }
  100% {
    transform: translateX(0px) translateY(50px) scale(1) rotate(0deg) skewX(0deg) skewY(0deg);
    opacity: 0.01;
    filter: blur(4px);
  }
`;

const rotate = keyframes`
from {
    transform:rotate(0);
    
  }
  to {
     transform:rotate(360deg);

  }
`;

export const IndexComponentMainDiv = styled.main`
  .is-visible .reveal-text-span {
    animation: ${enterKeyframes} 0.7s ease-out forwards;
  }
  .index-button-holder {
    display: flex;
    justify-content: stretch;
    align-items: center;

    min-width: 180px;
    img {
      height: 40% !important;
    }
  }
`;

export const IndexComponentHeaderHeroDiv = styled.div`
  background: var(--main-bg);
  border-radius:0px 0px 40px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px 40px 40px;
  overflow-y: hidden;
  .gradient-container {
    width:100%;

    position: absolute;
    height:110%;
    padding:0px 1px;;
    left: 0;
    right: 0;
    overflow: visible;
    top:0;
  }
  .blob-left {
    width: 43%;
    height: 50%;
    background: red;
    position: absolute;
    bottom: 0;
    border-radius:100% 100% 0% 40%;
    > div {
      background: none;
      width: 100%;
      height: 100%;
      border-radius: 100% 40% 100% 40%;
      left: 0;
      transform: rotateZ(100deg) translateX(1px);
    }
  }

  .index-header-hero-video-holder {
    display: content;
    > div {
      position: absolute;
      width: 1437;
      height: 958;
      top: 0;
      right: -300px;
    }
  }
  .index-header-hero-content-holder {
    z-index: 3;
    display: flex;
    flex-direction: column;
    gap: 140px;
    width: 100%;
    max-width: 1140px;
    padding: 0;
  }
  .index-header-hero-section-top {
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: fit-content;
    padding: 0;
  }
  .section-text {
    display: flex;
    gap: 24px;
    flex-direction: column;
  }
  .section-title-block {
    display: flex;
    gap: var(--size-1);
    flex-direction: column;
    max-width: 595px;
    width: 100%;
  }

  .block-header {
    width: fit-content;
    height: fit-content;
  }
  .block-header-text-wrapper {
    background: var(--main-bg);
    border-radius: 14px;
    display: flex;
    gap: 10px;
    padding: 6px 12px;
    white-space: pre;
    text-transform: uppercase;
    > p {
      padding: 0;
      font-size: 14px;
      font-family: "Inter", "Inter Placeholder", sans-serif;

      margin: 0;
    }
  }

  .block-header-radial-gradient {
    border-radius: 99px;
    background: linear-gradient(
      90deg,
      rgb(105, 51, 0) 0%,
      rgb(128, 30, 0) 32.88288288288289%,
      rgb(0, 0, 0) 54.054054054054056%,
      rgb(0, 105, 166) 100%
    );
    display: flex;
    gap: 8px;
    padding: 1.5px;
    align-items: center;
    width: 100%;
  }

  .section-description-block {
    display: flex;
    gap: 24px;
    flex-direction: column;
    width: fit-content;
    max-width: 595px;
  }
  .block-cta-holder {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .block-cta-button-holder {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    align-items: center;
    padding: 0px;
  }
  .index-header-hero-section-bottom {
    z-index: 1;
    display: flex;
    flex-direction: column;
    padding: 100px 0;
    overflow: hidden;
    align-items: center;
  }
`;
export const IndexComponentHeaderBottomHeroContainer = styled.div`
  transform: translateX(-50%);
  position: absolute;
  will-change: transform;
  top: 0;
  left: 50%;
  height: 100%;
  z-index: 2;
  .chat-modal-container {
  }
  .chat-modal-content-holder {
    border-radius: 20px;
    display: flex;
    will-change: transform;
    align-items: center;
    gap: 0;
    width: 782px;
    max-width: 782px;
    padding: 6px;
    overflow: hidden;
  }

  .background-fill {
    background: rgba(0, 0, 0, 0);
    background-image: linear-gradient(
      270deg,
      rgb(165, 125, 25) 0.105574%,
      /* Dark Mustard/Gold */ rgb(161, 115, 69) 33.3685%,
      /* Deep Bronze/Brown */ rgb(0, 0, 0) 51.4886%,
      /* Pure Black Void */ rgb(97, 150, 242) 93.0708% /* Cinematic Blue Pop */
    );
    background-clip: border-box;
    background-origin: padding-box;
    position: absolute;
    inset: -345px -164px;
    transform: rotate(107deg);
    overflow: hidden;
  }
  .chat-modal-content {
    background: var(--main-bg);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px;
    overflow: hidden;
    flex: 1;
  }
  .chat-modal-content-section {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    flex: 1;
    > div {
      display: flex;
      gap: 8px;
    }
  }
  .chat-modal-model-selector {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #ffffff14;
    backdrop: blur(2px);
  }
  .chat-modal-selector {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ffffff14;
    backdrop-filter: blur(2px);
  }
  .chat-modal-selector-large-padding {
    padding: 8px 12px;
  }
  .icon-container {
    image-rendering: pixelated;
    flex-shrink: 0;
    fill: var(--main-bg);
    color: var(--main-bg);
    opacity: 0.5;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .small {
      width: 20px;
      height: 20px;
    }
  }
  .chat-modal-action-container {
    display: flex;
    gap: 8px;
  }
  .chat-modal-action-holder {
    justify-content: space-between;
  }
  .openai {
    color: white;
    width: 27px;
    height: 27px;
    padding: 0;
    margin: 0px;
  }
  .model-text-wrapper {
    justify-content: center;
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    word-break: break-word;
    width: 81px;
    > p {
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .text-wrapper {
    justify-content: center;
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    word-break: break-word;
    > p {
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      text-transform: capitalize;
      font-family: Inter, "Inter Placeholder", sans-serif;
    }
  }
  .chat-modal-input-text {
    font-family: "Inter", "Inter Placeholder", sans-serif;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0em;
    line-height: 1.2em;
    color: rgba(255, 255, 255, 0.8);
    padding: 0px;
    width: 100%;
    height: 100%;
    position: relative;
    > span {
    }
  }
  .blinking-cursor {
    color: rgba(255, 255, 255, 0.75);
    opacity: 1;
    animation: ${blinkingCursor} linear infinite 0.9s;
  }
`;
export const IndexComponentHeaderBottomImageContainer = styled.div`
  .image-container {
    position: absolute;
    border-radius: inherit;
    corner-shape: inherit;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .dashboard-image-container {
    aspect-ratio: 2.08054;
    height: 539px;
    will-change: filter;
    flex: 1 0 0;
    width: 100%;
    min-width: 1px;
    position: relative;
    overflow: hidden;
    -webkit-mask: linear-gradient(#000 0%, #0000 100%);
    mask: linear-gradient(#000 0%, #0000 100%);
  }
`;
export const IndexComponentHeaderHeroHeaderTextWrapper = styled.div`
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  outline: none;

  h1 {
    margin: 0;
    padding: 0px;
    overflow-wrap: break-word;
    text-wrap-mode: wrap;
    word-spacing: normal;
    text-wrap-style: auto;
    white-space-collapse: preserve;
    font-kerning: normal;
    font-variant-ligatures: common-ligatures;
  }

  .text-exit-wrapper {
    display: inline-block;
    animation: ${exitKeyframes} linear;
    animation-timeline: view();
    animation-range: exit 0% exit 100%;
    height: fit-content;
  }

  .block-header-h1-text-span {
    display: inline-block;
    opacity: 0.01;
    filter: blur(4px);
    transform: translateY(10px);
    text-transform: capitalize;
    bosrder: 1px solid green;
  }
  .image {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    corner-shape: inherit;
    object-position: center;
    object-fit: cover;
  }
`;

export const IndexComponentHeaderHeroDecriptionTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  white-space: pre-wrap;
  > p {
    margin: 0;
    padding: 0px;
    font-size: 18px;
    font-weight: 400;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    text-transform: capitalize;
    line-height: 1.6em;
  }

  &.is-visible .block-description-p-text-span {
    animation: ${enterKeyframes} 0.7s ease-out forwards;
  }
`;
const marqueeScroll = keyframes`
0%{
transform:translatex(0px)
}
100%{
transform:translatex(-1468px)

}`;

export const IndexComponentTrustedSection = styled.div`
  .trusted-section-container {
    flex-flow: row;
    align-items: center;
    gap: 0;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    height: min-content;
    padding: 100px 40px;
    display: flex;
    position: relative;
    overflow: visible;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }
  .trusted-section-text {
    white-space: pre-wrap;
    word-break: break-word;
    word-wrap: break-word;
    flex: none;
    width: 100%;
    flex-grow: 1;
    height: auto;
    position: relative;
    text-align: center;
    > p {
      font-size: 18px;
      font-weight: 400;
      font-family: "Inter", "Inter Placeholder", sans-serif;
      line-height: 1.2em;
      padding: 0;
      color: #808080;

      margin: 0;
    }
  }
  .trusted-section-holder {
    flex-flow: column;
    flex: 1 0 0;
    place-content: center;
    align-items: center;
    gap: 32px;
    width: 1px;
    max-width: 1140px;
    height: min-content;
    padding: 0;
    display: flex;
    position: relative;
    overflow: visible;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }
  .trusted-section-marque-container {
    width: 100%;
    cursor: pointer;
    position:relative > div {
      flex-flow: row;
      place-content: center;
      align-items: center;
      gap: 0;
      width: 100%;
      height: min-content;
      padding: 0;
      display: flex;
      position: relative;
      overflow: visible;
    }
    .trusted-section-marque-gradient-cover {
      width: 60px;
      position: absolute;
      top: 0;
      z-index: 1;
      bottom: 0;
    }
    .trusted-section-marque-gradient-cover-left {
      left: 0;
      background: linear-gradient(
        90deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .trusted-section-marque-gradient-cover-right {
      right: 0;
      background: linear-gradient(
        270deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }

    .trusted-section-marque-scroll-holder {
      flex: 1 0 0;
      width: 1px;
      height: 50px;
      position: relative;
      > section {
        display: flex;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        place-items: center;
        margin: 0px;
        padding: 0px;
        list-style-type: none;
        opacity: 1;
        overflow: hidden;
      }
    }
    .trusted-section-marque-scroll-list {
      list-style-type: none;
      display: flex;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      align-items: center;
      margin: 0px;
      padding: 0px;
      gap: 60px;
      position: relative;
      flex-direction: row;
      transform: translateX(-1468px);
      animation: infinite ${marqueeScroll} 16s linear;
      &:hover {
        animation-play-state: paused;
      }
    }
    .trusted-section-marque-scroll-list-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #808080;
    }
    .trusted-section-marque-scroll-list-item-icon {
      width:  34px;
      height: 34px;
      color: #808080;
      fill: #808080;
      object-fit: contain;
      filter: grayscale(100%) brightness(0.7);
      opacity: 0.8;
            border-radius:100%;

    }
    .trusted-section-marque-scroll-list-item-text {
      > div {
        > p {
          font-size: 24px;
          padding: 0;
          font-family: "Inter", "Inter Placeholder", sans-serif;
white-space:nowrap;
          font-weight: 700;
          text-transform: capitalize;
          margin: 0;
          color: #808080;
        }
      }
    }
  }
`;

export const IndexComponentFeatureSection = styled.section`
  display: flex;
  align-items: center;
  justify-items: center;
  padding: 100px 40px;
  height: min-content;
  flex-direction: column;
  > div {
    gap: 60px;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    max-width: 1140px;
  }
  .feature-section-header-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 24px;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }
  }
  .feature-section-header-text,
  .feature-section-description-text {
    white-space: pre-wrap;
    width: 100%;
    max-width: 745px;
    height: auto;
    display: flex;
    flex-direction: column;
    text-align: center;

    > h2 {
      margin: 0;
      font-family: " General Sans", "General Sans Placeholder", sans-serif;
      padding: 0;
      font-weight: 500;
      line-height: 1em;
      font-size: var(--size-6);
      letter-spacing: -2px;
    }
  }
  .feature-section-description-text {
    max-width: 700px;

    font-family: "Inter", sans-serif;

    > p {
      margin: 0px;
      padding: 0px;
      font-size: 18px;
      font-weight: 400;
      line-height: 1.4em;
    }
  }
  .feature-section-bento-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .feature-section-bento-toprow,
  .feature-section-bento-bottomrow {
    display: grid;
    width: 100%;
    gap: 24px;
    grid-template-columns: 1fr 1.7fr;
    grid-template-rows: auto auto;
  }
  .feature-section-bento-bottomrow {
    grid-template-columns: 2fr 1fr;
  }
  .feature-section-bento-card {
    background: #191919;
    border-radius: 16px;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    gap: 10px;

    flex: 1;
    padding: 0px;
    position: relative;
  }
  .gradient {
    position: absolute;
    width: 100%;
    height: 100%;

    border-radius: 16px;
    overflow: hidden;
    &:before {
      content: "";

      background: conic-gradient(
        from 344deg at 50% 50%,
        #0000 320.4deg,
        var(--token-d036317c-cd8d-4b85-8162-192e6730b357, #da4e24) 334.8deg,
        #0000 349.2deg
      );
      z-index: 0;
      flex: none;
      position: absolute;
      inset: -166px -90px -158px -93px;
      overflow: hidden;

      animation: ${rotate} 10s linear infinite;
    }
  }
  .feature-section-bento-card-container {
    border-radius: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 8px;
    margin: 1px;
    background: #000;
  }
  .feature-section-bento-card-text-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 22px 22px;
  }
  .feature-section-bento-card-header-text {
    display: flex;
    flex-direction: column;
    white-space: pre-wrap;
    word-break: break-word;
    word-wrap: break-word;

    flex: none;
    width: 100%;
    height: auto;
    position: relative;
    > h3,
    > p {
      margin: 0;
      font-size:16px;
      line-height:1.4em;
      padding: 0;
    }
    > h3 {
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.1em;
    }
  }
  .feature-section-bento-card-text {
  }
  .feature-section-bento-card-icon-holder {
    display: flex;
    align-items: center;
    width: 100%;
    overflow: visible;
  }
  .feature-section-bento-card-grid-small {
    flex: none;
    display: flex;
  }
  .feature-section-bento-card-grid-big {
    display: flex;
  }
`;

